/*
 * Potzillas — Poptávka (individuální nacenění)
 * Otevírá globální modal z tlačítek [data-quote-open] (košík i produkt),
 * načte položky (košík přes /cart.js, produkt z data atributů) a odešle
 * je i s kontaktem do Make.com webhooku. Make pošle e-mail; ty pak založíš
 * draft order s vlastní cenou.
 */
(function () {
  'use strict';

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v == null ? '' : v).trim());
  }

  function money(cents) {
    return Math.round((cents || 0) / 100) + ' Kč';
  }

  /* Vybraná varianta se musí číst AŽ PŘI KLIKU.
     Dawn při přepnutí varianty překresluje jen cenu, sklad a pár dalších ID
     (product-info.js → handleUpdateProductInfo), tlačítko poptávky nikdy —
     atribut data-quote-product by tedy navždy nesl variantu z načtení stránky,
     tedy tu první dostupnou (nejmenší). Zdrojem pravdy je JSON
     [data-selected-variant] uvnitř <variant-selects>, který Dawn při každé
     změně varianty vymění celý. */
  function selectedVariant(trigger) {
    var scope = (trigger.closest && trigger.closest('product-info')) || document;
    var node = scope.querySelector('[data-selected-variant]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Shopify vrací adresy obrázků protokolově relativní („//potzillas.cz/…“).
     V prohlížeči to funguje, ale v e-mailu ne — poštovní klient nemá vůči čemu
     „//“ rozložit a místo fotky zobrazí prázdný rámeček. Proto vždy doplníme
     protokol. (Z /cart.js chodí adresy absolutní, tam je to bez efektu.) */
  function absoluteImage(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    if (src.charAt(0) === '/') return window.location.origin + src;
    return src;
  }

  function sizedImage(src, w) {
    if (!src) return '';
    var out = absoluteImage(src);
    if (/[?&]width=/.test(out)) return out;
    return out + (out.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* Množství z produktové stránky — zákazník ho nastaví ještě před kliknutím
     na Poptávku, tak ať nemusí psát „3 ks“ do poznámky. */
  function selectedQuantity(trigger) {
    var scope = (trigger.closest && trigger.closest('product-info')) || document;
    var input = scope.querySelector('.quantity__input, input[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) : 1;
    return qty > 0 ? qty : 1;
  }

  function productItem(trigger) {
    // Fallback = to, co vyrenderoval server (platí pro produkty bez variant
    // a pro případ, že by picker na stránce nebyl).
    var title = trigger.getAttribute('data-quote-product') || '';
    var image = trigger.getAttribute('data-quote-image') || '';
    var sku = '';
    var variantId = '';

    var variant = selectedVariant(trigger);
    var base = trigger.getAttribute('data-quote-title') || '';
    if (variant && base) {
      title = base;
      if (variant.title && variant.title !== 'Default Title') {
        title += ' – ' + variant.title;
      }
      if (variant.featured_image && variant.featured_image.src) {
        image = variant.featured_image.src;
      }
    }
    if (variant) {
      sku = variant.sku || '';
      variantId = variant.id || '';
    }

    if (!title) return null;
    return {
      title: title,
      qty: selectedQuantity(trigger),
      price: '',
      image: sizedImage(image, 120),
      sku: sku,
      variant_id: variantId,
    };
  }

  function init() {
    var overlay = document.querySelector('[data-quote-overlay]');
    if (!overlay) return;

    var modal = overlay.querySelector('.pq-modal');
    var form = overlay.querySelector('[data-quote-form]');
    var itemsBox = overlay.querySelector('[data-quote-items]');
    var statusEl = overlay.querySelector('[data-quote-status]');
    var submitBtn = form ? form.querySelector('[type="submit"]') : null;
    var endpoint = form ? form.getAttribute('data-webhook') || '' : '';
    var successMsg = form ? (form.getAttribute('data-success') || 'Děkujeme! Poptávku jsme přijali.') : '';

    var openedAt = 0;
    var currentItemsText = '';
    var currentItemsJson = '[]';
    var currentItemsHtml = '';
    var currentSource = '';

    function showStatus(type, text) {
      if (!statusEl) return;
      statusEl.textContent = text;
      statusEl.className = 'pq-status pq-status--' + type;
      statusEl.hidden = false;
      statusEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function clearStatus() {
      if (statusEl) { statusEl.hidden = true; statusEl.textContent = ''; }
    }

    // Zavři vysouvací košík, ať se modal neotevře za ním (hlavně na mobilu).
    function closeCartDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        drawer.classList.remove('active', 'animate');
      }
      document.body.classList.remove('overflow-hidden');
    }

    function renderItems(items) {
      if (!itemsBox) return;
      if (!items.length) { itemsBox.hidden = true; itemsBox.innerHTML = ''; return; }
      // POZOR: tohle je JEDINÉ místo, které vidí zákazník — SKU sem nepatří.
      // Do poptávky (items_text / items_html / items_json) jde, tam ho
      // potřebujeme my.
      var rows = items.map(function (i) {
        var price = i.price ? ' <span>(' + i.price + ')</span>' : '';
        return '<li class="pq-items__row">' + escapeHtml(i.title) +
          ' <span>— ' + i.qty + '×</span>' + price + '</li>';
      }).join('');
      itemsBox.innerHTML = '<p class="pq-items__title">Položky poptávky</p><ul class="pq-items__list">' + rows + '</ul>';
      itemsBox.hidden = false;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    // HTML položek pro e-mail (inline styly + tabulka kvůli poštovním klientům).
    function buildItemsHtml(items) {
      return items.map(function (i) {
        var img = i.image
          ? '<td width="64" style="padding:6px 12px 6px 0;vertical-align:top;"><img src="' + i.image + '" width="56" height="56" alt="" style="display:block;border-radius:8px;object-fit:cover;"></td>'
          : '';
        var meta = i.qty + '×' +
          (i.sku ? ' &middot; ' + escapeHtml(i.sku) : '') +
          (i.price ? ' &middot; ' + i.price : '');
        return '<table role="presentation" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:6px 0;"><tr>' +
          img +
          '<td style="vertical-align:top;font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#0B0B0B;line-height:1.4;">' +
          '<strong>' + escapeHtml(i.title) + '</strong><br><span style="color:#777777;">' + meta + '</span></td>' +
          '</tr></table>';
      }).join('');
    }

    function setItems(items) {
      renderItems(items);
      currentItemsJson = JSON.stringify(items);
      currentItemsText = items.map(function (i) {
        return '• ' + i.title + ' — ' + i.qty + '×' +
          (i.sku ? ' · ' + i.sku : '') +
          (i.price ? ' (' + i.price + ')' : '');
      }).join('\n');
      currentItemsHtml = buildItemsHtml(items);
    }

    function openModal() {
      clearStatus();
      if (form) {
        var fieldsHidden = form.querySelector('.pq-form__fields');
        if (fieldsHidden) fieldsHidden.removeAttribute('hidden');
      }
      if (submitBtn) { submitBtn.disabled = false; submitBtn.classList.remove('is-loading'); }
      closeCartDrawer();
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      openedAt = Date.now();
      var firstInput = form ? form.querySelector('input, textarea') : null;
      if (firstInput) firstInput.focus();
    }

    function closeModal() {
      overlay.hidden = true;
      document.body.style.overflow = '';
    }

    function loadCart() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = (cart.items || []).map(function (it) {
            var v = (it.variant_title && it.variant_title !== 'Default Title') ? ' / ' + it.variant_title : '';
            return {
              title: it.product_title + v,
              qty: it.quantity,
              price: money(it.final_line_price),
              url: it.url,
              image: sizedImage(it.image, 120),
              sku: it.sku || '',
              variant_id: it.variant_id || '',
            };
          });
          setItems(items);
        })
        .catch(function () { setItems([]); });
    }

    // Otevření přes delegaci (tlačítka se v košíku překreslují).
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quote-open]');
      if (trigger) {
        e.preventDefault();
        currentSource = trigger.getAttribute('data-quote-source') || 'cart';
        if (currentSource === 'product') {
          var picked = productItem(trigger);
          setItems(picked ? [picked] : []);
        } else {
          setItems([]);
          loadCart();
        }
        openModal();
        return;
      }
      if (e.target.closest('[data-quote-close]') || e.target === overlay) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closeModal();
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var honeypot = form.querySelector('[name="company_url"]');
        if (honeypot && honeypot.value) { showStatus('success', successMsg); return; }
        if (Date.now() - openedAt < 1500) { showStatus('success', successMsg); return; }

        if (!endpoint) {
          showStatus('error', 'Poptávka zatím není propojená (chybí webhook URL v nastavení).');
          return;
        }

        var emailInput = form.querySelector('[name="email"]');
        if (emailInput) {
          emailInput.classList.remove('pq-field__input--error');
          if (!isValidEmail(emailInput.value)) {
            emailInput.classList.add('pq-field__input--error');
            emailInput.focus();
            showStatus('error', 'Zadejte e-mail ve správném tvaru.');
            return;
          }
        }

        if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

        if (submitBtn) { submitBtn.disabled = true; submitBtn.classList.add('is-loading'); }

        var data = new FormData(form);
        data.delete('company_url');
        data.append('items_text', currentItemsText);
        data.append('items_html', currentItemsHtml);
        data.append('items_json', currentItemsJson);
        data.append('source', 'potzillas-quote-' + currentSource);
        data.append('page_url', window.location.href);
        data.append('submitted_at', new Date().toISOString());

        fetch(endpoint, { method: 'POST', body: data })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            var fields = form.querySelector('.pq-form__fields');
            if (fields) fields.setAttribute('hidden', '');
            if (itemsBox) itemsBox.hidden = true;
            form.reset();
            showStatus('success', successMsg);
          })
          .catch(function () {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.classList.remove('is-loading'); }
            showStatus('error', 'Něco se nepovedlo. Zkuste to prosím znovu, nebo nám napište na info@potzillas.cz.');
          });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
